import React from 'react'
import TextRow from '../Rows/TextRow'
import { Shadow } from '../../types/Shadow.types'
import NumberRow from '../Rows/NumberRow'
import { FormTabProps } from '../../types/FormTab.types'

const IdsConfigurationSection = ({ formState, handleChangeByShadow }: FormTabProps) => {
    const inputChanged = handleChangeByShadow(Shadow.Datasyncd);

    return (
        <>
            <TextRow
                label="Domena IDS"
                caption="RESTAPI_HOST"
                name="datasyncd.RESTAPI_HOST"
                value={formState.datasyncd?.RESTAPI_HOST}
                onChange={inputChanged}
            />

            <TextRow
                label="Ścieżka do pliku OAuth API"
                caption="RESTAPI_OAUTHFILE"
                name="datasyncd.RESTAPI_OAUTHFILE"
                value={formState.datasyncd?.RESTAPI_OAUTHFILE}
                onChange={inputChanged}
            />

            <TextRow
                label="Login API"
                caption="RESTAPI_USER"
                name="datasyncd.RESTAPI_USER"
                value={formState.datasyncd?.RESTAPI_USER}
                onChange={inputChanged}
            />

            <TextRow
                label="Hasło API"
                caption="RESTAPI_PASSWORD"
                name="datasyncd.RESTAPI_PASSWORD"
                value={formState.datasyncd?.RESTAPI_PASSWORD}
                onChange={inputChanged}
            />

            {/*TODO look into making this a proper select*/}
{/*            <ListRow
                label="Protokół komunikacji"
                caption="RESTAPI_PROTOCOL"
                name="datasyncd.RESTAPI_PROTOCOL"
                value={formState.datasyncd?.RESTAPI_PROTOCOL}
                onChange={selectChanged}
                items={['http', 'https']}
            />*/}

            <TextRow
                label="Protokół komunikacji"
                caption="RESTAPI_PROTOCOL"
                name="datasyncd.RESTAPI_PROTOCOL"
                value={formState.datasyncd?.RESTAPI_PROTOCOL.toUpperCase()}
                onChange={inputChanged}
            />

            <NumberRow
                label="Wersja protokołu API"
                caption="RESTAPI_VERSION"
                name="datasyncd.RESTAPI_VERSION"
                value={formState.datasyncd?.RESTAPI_VERSION}
                onChange={inputChanged}
            />

            <NumberRow
                label="Limit ilości pobieranych encji przez automat na jedno zapytanie"
                caption="RESTAPI_FETCH_LIMIT"
                name="datasyncd.RESTAPI_FETCH_LIMIT"
                value={formState.datasyncd?.RESTAPI_FETCH_LIMIT}
                onChange={inputChanged}
            />

        </>
    )
}

export default IdsConfigurationSection
